<div class="navbar-discover-container">
    <div class="sidebar-logo">
        <div class="logo-container">
            <img src="assets/images/logo_monex_dashboard.png" alt="monex" class="px-1 pb-0 pt-1" width="241" height="95"
                 loading="lazy">
        </div>
    </div>
    <div class="page-wrapper">
        <app-navbar [showOnlyTranslateIcon]="true"></app-navbar>
    </div>
</div>
<div class="page-content-discover-container  justify-content-center container-fluid">
    <div class="text-center primary-title ">
        <p>{{ "discoverYourBank.title" | translate }}</p>
    </div>

    <div class="categories-title">
        <p class="explore-label primary-title font-family-raleway">
            {{ "discoverYourBank.categoryTitle" | translate }}
        </p>
    </div>

    <div class="categories row">
        <div *ngFor="let category of categories" class="mt-5">
            <div class="category-container" [class.selected]="isCategorySelected(category)">
                <div class="category"
                     [ngStyle]="{'background-color': !category.enable ? '#EEEEEE' : '#FFFFFF', 'cursor': category.enable ? 'pointer' : 'default'}"
                     (click)="category.enable && selectCategory(category)">
                    <img class="w-100 p-2" src="assets/images/discover/{{category.icon}}">
                    <div *ngIf="!category.enable" class="soon">{{ "discoverYourBank.soon" | translate }}</div>
                </div>
                <div class="category-label primary-color font-family-raleway">
                    {{ getIconLabel(category) | translate }}
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedCategory" class="accordion-container mt-5">
        <div class="accordion-header">
            <div class="header-content">
                <div class="header-left">
                    <img class="category-icon" src="assets/images/discover/{{selectedCategory.icon}}"
                         alt="{{getIconLabel(selectedCategory) | translate}}">
                    <p class="primary-color font-family-raleway accordion-title">{{ getIconLabel(selectedCategory) | translate }}</p>
                </div>
                <div class="header-right">
                    <button class="close-btn" (click)="selectCategory(selectedCategory)">
                        <i class="pi pi-times"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="accordion-content">
            <ng-container *ngFor="let item of jsonCategory.tabs">
                <div class="content-item">
                    <div class="content-description">
                        <p-accordion >
                            <p-accordionTab [header]="item.label" >
                                <div class="content-subtitle primary-color mb-2">
                                    {{ item?.description }}
                                </div>
                                <div class="content-item">
                                    <div class="content-description">
                                        <ol class="features-list primary-color" *ngIf="item?.items">
                                            <li *ngFor="let feature of item.items"
                                                [innerHTML]="getInnerHtml(feature)"></li>
                                        </ol>
                                        <div class="tip-box" *ngIf="item && item.tip">
                                            <div class="tip-icon d-flex align-items-center">
                                                <img ngSrc="assets/icons/tip.svg" class="tip-icon" alt="Monex"
                                                     height="14" width="14">
                                                <p class="ms-2"><span [innerHTML]="item.tip"></span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </p-accordionTab>
                        </p-accordion>
                    </div>
                </div>
            </ng-container>
        </div>
        <div *ngIf="jsonCategory.info && jsonCategory.info !==''" class="soon-functions-container primary-color mt-3">
            {{'discoverYourBank.funcionalityPending' | translate}}
        </div>
    </div>

</div>
